module.exports = __webpack_public_path__ + "static/media/au.fd18c797.svg";